import { Outlet, useLocation } from 'react-router-dom'
import { SidebarProvider, SidebarInset } from 'components/ui/sidebar'
import { AppSidebar } from 'components/layout/app-sidebar'
import { Topbar } from 'components/layout/topbar'
import { UserProvider } from 'components/context/user-context'
import { useUser } from 'components/context/user-context'
import { isPathAllowedForLevel } from 'lib/access'

function DashboardShell() {
  const { pathname } = useLocation()
  const { accessLevel, loading } = useUser()

  if (loading) {
    return (
      <SidebarProvider>
        <AppSidebar />
        <SidebarInset>
          <Topbar />
          <div className="flex-1 overflow-auto">
            <div className="p-6 text-sm text-muted-foreground">Loading user profile...</div>
          </div>
        </SidebarInset>
      </SidebarProvider>
    )
  }

  if (!isPathAllowedForLevel(accessLevel, pathname)) {
    return (
      <SidebarProvider>
        <AppSidebar />
        <SidebarInset>
          <Topbar />
          <div className="flex-1 overflow-auto">
            <div className="flex h-full items-center justify-center p-6">
              <div className="max-w-md text-center">
                <h2 className="text-xl font-semibold text-foreground">Access Restricted</h2>
                <p className="mt-2 text-sm text-muted-foreground">
                  You only have access to Portfolio Dashboard, Proposals, Awards, Projects, and Workplans.
                </p>
              </div>
            </div>
          </div>
        </SidebarInset>
      </SidebarProvider>
    )
  }

  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <Topbar />
        <div className="flex-1 overflow-auto">
          <Outlet />
        </div>
      </SidebarInset>
    </SidebarProvider>
  )
}

export default function DashboardLayout() {
  return (
    <UserProvider>
      <DashboardShell />
    </UserProvider>
  )
}
